<template>
  <div class="main-survey">
    <div class="survey-title">博智林智能地磅</div>
    <div class="survey-brief">产品背景</div>
    <div class="survey-content advantage-content">
      作为材料管理重要的组成部分，我们一直将传统地磅看做简单的称重工具，不仅需要手动完成大量进场数据的录入，而且需要人工监督避免司机作弊和上磅不规范的情况。人员效率低下，发现问题又难以追溯。智慧地磅实现了数据自动采集、本地存储和远程共享，可以帮助企业有效积累材料数据资产，发现问题易追溯。
    </div>
    <div class="survey-brief">产品简介</div>
     <div class="survey-content advantage-content">
      物联网技术、云计算、称重技术集于一体，辅助司机自行称重，全方位监控作弊行为，实现数据自动采集和远程共享，有效积累材料数据资产，实现无人值守智能管理，随时随地掌控材料验收现场，识别材料验收风险。博智林智能地磅可独立运行于项目，自身具有材料称重、数据存储分析的业务，也可联动智慧工地等第三方管理系统，数据云同步。
    </div>
    <div class="survey-img">
      <img
        src="@/assets/images/digi-tech/weighbridge-1.png"
        alt="博智林BIM协同平台"
        width="100%"
      />
    </div>

    <div class="data-source">*数据来源于博智林数字科技</div>
    <div class="robot-btn" @click="isShow = true">购买联系</div>
    <Qrcode v-model="isShow"></Qrcode>
  </div>
</template>
<script>
import Qrcode from "@/components/Qrcode.vue";

export default {
  name: "digi-weighbridge",
  components: {
    Qrcode,
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/digi.less";
</style>



